import axios from 'axios';
import httpInterceptor from '../helpers/httpInterceptor';
const PRODUCT_END_POINT = process.env.REACT_APP_PRODUCT_API_ENDPOINT;

const csvUploadFeatureRequests = {};

export default {
  downloadCSV(params) {
    return httpInterceptor.get(PRODUCT_END_POINT + 'createCSV', {
      params
    })
  },
  getCreateCsvStatus() {
    return httpInterceptor.get(PRODUCT_END_POINT + 'createCSV/status');
  },
  acknowledgeCsvDownloaded() {
    return httpInterceptor.post(PRODUCT_END_POINT + 'createCSV/downloaded');
  },
  pricesImportCsv(file) {
    const fd = new FormData();
    fd.append("file", file);
    return httpInterceptor.post(PRODUCT_END_POINT + 'csv/pricesImport', fd);
  },
  getCsvUploadFeature(shopName) {
    if (!shopName) {
      return Promise.reject(new Error('shopName is required'));
    }
    if (!csvUploadFeatureRequests[shopName]) {
      csvUploadFeatureRequests[shopName] = axios
        .get(PRODUCT_END_POINT + 'csv/upload-feature', {
          params: { shopName },
          responseType: 'json',
          timeout: 180000,
        })
        .catch((err) => {
          delete csvUploadFeatureRequests[shopName];
          throw err;
        });
    }
    return csvUploadFeatureRequests[shopName];
  },
}
